import React, { useEffect, useState } from 'react';
import { Model } from 'survey-core';
import { VisualizationPanel } from 'survey-analytics';

const SurveyResultsComponent = ({ surveyJson, surveyData }) => {
    const [survey, setSurvey] = useState(null);
    const [vizPanel, setVizPanel] = useState(null);

    useEffect(() => {
        if (!survey) {
            const newSurvey = new Model(surveyJson);
            setSurvey(newSurvey);
        }

        if (!vizPanel && survey) {
            const newVizPanel = new VisualizationPanel(
                survey.getAllQuestions(),
                surveyData,
                {}
            );
            newVizPanel.showHeader = true;
            newVizPanel.render("surveyAnalyticsContainer");
            
            setVizPanel(newVizPanel);
        }

        if (vizPanel) {
            survey.getAllQuestions().forEach(function (question) {
                var visualizer = vizPanel.getVisualizer(question.propertyHash.name);
                visualizer.showHeader = false;
                if (question.getType() === "matrix") {
                    visualizer.setChartType("stackedbar");
                }

            })
        }
    }, [survey, vizPanel, surveyJson, surveyData]);

    return <div id="surveyAnalyticsContainer"></div>;
};

export default SurveyResultsComponent;
